"use strict";

import $ from "jquery";

const toggleTechnologyList = function () {
  $(".custom-tech-nav").toggleClass("expanded");
  $(".custom-tech-nav .search-row h3").toggleClass("expanded");
};

const setupSearch = function () {
  const $techNavContainer = $(".custom-tech-nav");

  const $input = $techNavContainer.find("#technology-name-filter");

  const $topLevelNodes = $techNavContainer.find("ul.parent-list > li");
  const $nodes = $techNavContainer.find("li");
  const $childNodes = $nodes.not($topLevelNodes);

  $input.on("keyup", () => {
    const val = $input.val();

    $techNavContainer.addClass("expanded");

    $nodes.removeClass("matching");

    if (val.length === 0) {
      $techNavContainer.removeClass("searching");

      return;
    }

    $techNavContainer.addClass("searching");

    $nodes.each((i, e) => {
      const $this = $(e);

      const searchTerms = $this.data("searchTerms") || "";

      if (searchTerms.match(new RegExp(val, "gi"))) {
        $this.addClass("matching");
      }
    });

    $childNodes.filter(".matching").each((i, e) => {
      $(e).closest("ul").closest("li").addClass("matching");
    });
  });
};

$(document).on("turbolinks:load", function () {
  // $.extend(true, {}, window.ExternalDataCardGrid).setupForMarketsPage();
  $("#technology-list-toggle").closest("h3").on("click", toggleTechnologyList);

  setupSearch();
});
